import { MutableRefObject, useEffect } from 'react';

interface UseOnKeyPressIfFocusedParams {
  eventKey: string;
  onPress: () => void;
  ref: MutableRefObject<unknown>;
}

const useOnKeyPressIfFocused = ({ eventKey, onPress, ref }: UseOnKeyPressIfFocusedParams) => {
  useEffect(() => {
    const handleOnPress = (event: KeyboardEvent) => {
      if (!ref.current) {
        return;
      }

      const pressedKeyIsEnter = event.key === eventKey;
      const isInFocus = ref.current === document.activeElement;
      if (!isInFocus || !pressedKeyIsEnter) {
        return;
      }

      onPress();
    };

    document.addEventListener('keypress', handleOnPress);
    return () => {
      document.removeEventListener('keypress', handleOnPress);
    };
  }, [onPress]);
};

export default useOnKeyPressIfFocused;
